'use client';
import React from 'react';
import HiperaliaInfoSectionCategories from '@/components/common/HiperaliaInfoSectionCategories';

interface AboutSectionCategoriesProps {
  categoryId: number;
  className?: string;
}

const AboutSectionCategories: React.FC<AboutSectionCategoriesProps> = ({ 
  categoryId,
  className = '' 
}) => {
  return (
    <div data-component-id="src/components/sections/AboutSectionCategories.tsx:15:4" data-component-path="src/components/sections/AboutSectionCategories.tsx" data-component-line="15" data-component-file="AboutSectionCategories.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${className}`}>
      <div data-component-id="src/components/sections/AboutSectionCategories.tsx:16:6" data-component-path="src/components/sections/AboutSectionCategories.tsx" data-component-line="16" data-component-file="AboutSectionCategories.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20w-full%22%7D" className="flex justify-center w-full">
        <HiperaliaInfoSectionCategories data-component-id="src/components/sections/AboutSectionCategories.tsx:17:8" data-component-path="src/components/sections/AboutSectionCategories.tsx" data-component-line="17" data-component-file="AboutSectionCategories.tsx" data-component-name="HiperaliaInfoSectionCategories" data-component-content="%7B%22elementName%22%3A%22HiperaliaInfoSectionCategories%22%7D" categoryId={categoryId} />
      </div>
    </div>
  );
};

export default AboutSectionCategories;
